function AdmissionGroupNotVisibleModalCtrl($scope, $uibModalInstance, modalHeader, onBtnClick, $timeout) {
  _initScope();

  function _initScope() {
    $scope.modalHeader = modalHeader;

    $scope.onClick = function ($event) {
      if (!$event) $event.preventDefault();

      if (onBtnClick) onBtnClick();
    };

    $scope.close = function () {
      $uibModalInstance.close(false);
    };

    $scope.timer = $timeout(() => {
      $scope.close();
    }, 10000);

    $scope.$on('$destroy', () => {
      if ($scope.timer) $timeout.cancel($scope.timer);
    });
  }
}

AdmissionGroupNotVisibleModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'modalHeader',
  'onBtnClick',
  '$timeout'
];

export default AdmissionGroupNotVisibleModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/admissionGroupNotVisible/controller.js